import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { useAddTransactionMutation } from "@/services/transaction.service";
import moment from "moment-timezone";
import Information from "./_information";
import { FormProvider, useForm } from "react-hook-form";
import "./style.css"
import { TransactionFieldForm } from "@/types/transaction.type";
import { uuidNull } from "@/constants/default";

export default function AddTransaction() {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [addTransaction, { isSuccess }] = useAddTransactionMutation()
    const methods = useForm<TransactionFieldForm>({
        defaultValues: {
            link_uploads: [{ link: "" }],
        }
    })
    const {handleSubmit, reset} = methods
    const [files, setFiles] = useState<File[]>([]);
    const [addAnother, setAddAnother] = useState(false)

    const onSubmit = (status: boolean) => handleSubmit(async (data) => {
        setAddAnother(status);
        let now = moment();
        const formData = new FormData();
        formData.append("business_unit_id", data.business_unit_id ? data.business_unit_id : uuidNull)
        formData.append("unitcode_id", data.unitcode_id)
        formData.append("transactiontype_id", data.transactiontype_id)
        formData.append("type", data.type.toString())
        formData.append("amount", data.amount)
        formData.append("description", data.description)
        formData.append("date", moment(`${data.date} ${now.hours()}:${now.minutes()}:${now.seconds()}.${now.milliseconds()}`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString())
        formData.append("status", Number(files?.length > 0).toString())
        if(!_.isEmpty(files)) {
            for (const file of files) {
                formData.append('images[]', file)
              }
        }
        data.link_uploads.forEach((item, idx) => {
            if(!_.isEmpty(item.link)) {
                formData.append(`link_uploads`, item.link)
            }
        })
        addTransaction(formData)
    })()

    useEffect(() => {
        if(isSuccess) {
            if (addAnother) {
                reset()
                setFiles([])
            } else {
                navigate(location, {state: {reload: true}})
            }
        }
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-999 flex h-full min-h-screen w-full items-center justify-center bg-black/90">
            <div className="w-full max-w-screen-lg rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
                <h3 className="text-xl dark:text-white text-center font-medium my-5 mt-8">
                    {t("transaction.add_transaction")}
                </h3>
                <form className="mx-5">
                    <FormProvider {...methods}>
                        <Information setFiles={setFiles} files={files} />
                    </FormProvider>
                    <div className="flex justify-center mt-3">
                        <div className="px-3">
                            <button type="button" onClick={() => navigate(location, {state: {reload: addAnother}})} className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div className="px-3">
                            <button
                                type="button"
                                className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white hover:bg-opacity-90"
                                onClick={() => {
                                    onSubmit(true)
                                }}
                            >
                                {t("modal.save_and_add_another")}
                            </button>
                        </div>
                        <div className="px-3">
                            <button
                                type="button"
                                className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white hover:bg-opacity-90"
                                onClick={() => onSubmit(false)}
                            >
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
